import { ThemeProvider } from '@emotion/react';
import Box from '@mui/material/Box';
import { createTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import BigNormalButton from 'components/atoms/Button/BigNormalButton';
import * as React from 'react';
import 'swiper/css';
import 'swiper/css/pagination';
import useStyles from './All.styles';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

interface IWelcomeProps {
  loading?: boolean;
  nextSlide?: () => void;
  prevSlide?: () => void;
  lastSlide?: () => void;
}

const Welcome: React.FC<IWelcomeProps> = ({ nextSlide, lastSlide }) => {
  const illustration = require('assets/Board/illustration_1.png');
  const header = require('assets/header.png');
  const classes = useStyles();

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Box
          style={{
            position: 'absolute',
          }}
          sx={{ height: { xs: '200px', sm: '300px' }, width: '100%' }}
        >
          <img
            src={header}
            alt={'img'}
            style={{ height: '100%', width: '100%' }}
          />
        </Box>
        <Box className={classes.body}>
          {/* <Box className={classes.skipTextSection}>
            <Typography
              className={classes.detailText}
              style={{ paddingBottom: "0px" }}
              onClick={()=>lastSlide && lastSlide()}
            >
              skip
            </Typography>
          </Box> */}
          <Box
            className={classes.illustrationSection}
            style={{ paddingTop: '10px' }}
            sx={{
              height: { xs: '120px', sm: '180px' },
              marginBottom: { xs: '50px', sm: '100px' },
            }}
          >
            <img src={illustration} alt={'img'} style={{ height: '100%' }} />
          </Box>
          <Box className={classes.titleTextSection}>
            <Typography className={classes.titleText}>
              Welcome to Buku!
            </Typography>
          </Box>
          <Typography className={classes.detailText}>
            The first social media focused on NFTs. We’ve designed the app to
            blur the lines of NFTs, allowing you to experience everything on the
            platform without ever touching NFTs.
          </Typography>
          <Box
            sx={{ paddingBottom: { xs: '0px', sm: '30px' } }}
            className={classes.buttonSection}
            onClick={() => nextSlide && nextSlide()}
          >
            <BigNormalButton color={'yellow'} text={'Next'} />
          </Box>
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default Welcome;
